import * as React from 'react';
import styled from '../theme';
import { Flex } from './Flex';
const BackDrop = styled.div`
  align-items: center;
  background-color: #00000080;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  visibility: visible;
  left: 0;
  right: 0;
  top: 60px;
  bottom: 0;
  position: fixed;
  z-index: 11;
  min-width: 1084px;
`;

const StyledDialog = styled.div`
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26), 0 2px 10px 0 rgba(0, 0, 0, 0.16);
  padding: 64px;
  width: 750px;
  color: #333333;
  opacity: 1;
  box-sizing: border-box;
`;

const Image = styled.img`
  width: 250px;
  max-width: 250px !important;
  margin-left: 20px;
`;

const PrimaryText = styled.span`
  color: #333333;
  font-weight: 900;
  font-size: 36px;
  line-height: 29.23px;
`;

const ContentText = styled.div`
  padding-top: 38px;
  font-size: 16px;
  line-height: 30px;
`;

interface Props {
  data: { title: string; message: string; image: any; showInApp: boolean };
  isOpen: boolean;
}

const OutageDialog: React.FunctionComponent<Props> = ({ data, isOpen }) => {
  if (!isOpen) return <></>;
  return (
    <>
      <BackDrop>
        <StyledDialog>
          <Flex>
            <div>
              <PrimaryText>{data.title}</PrimaryText>
              <ContentText>{data.message}</ContentText>
            </div>
            <div>
              <Image src={data.image} />
            </div>
          </Flex>
        </StyledDialog>
      </BackDrop>
    </>
  );
};

export default OutageDialog;
